module.exports = __webpack_public_path__ + "img/CRC1_Endothelial.441307d3.png";